import { Menu, menuTemplate as template } from '@microsoft/fast-foundation';
import { MenuComponent } from './Menu';
import styles from './Menu.styles.scss';
import { withStylePrefix } from '../common/withStylePrefix';
export const menuDefinition = {
    baseName: 'menu',
    baseClass: Menu,
    template: template,
    styles: withStylePrefix(styles),
};
/**
 * NOTE:
 *
 * Depends on `AnchoredRegion` in a hidden way, for detailed information see {@link chameleonAnchorRegion}
 */
export const chameleonMenu = MenuComponent.compose(menuDefinition);
